var e=(t,r={})=>{let n=new Intl.NumberFormat(t,r);return o=>n.format(o)};export{e as default};
